import { defineMessages } from 'react-intl';

export default defineMessages({
    paDetailsBrokenGlass: {
        id: 'fnol.pa.views.pa-glass-details.Details (Broken Glass)',
        defaultMessage: 'Details (Broken Glass)'
    },
    paGlassDamageDetails: {
        id: 'fnol.pa.views.pa-glass-details.Glass Damage Details',
        defaultMessage: 'Glass Damage Details'
    },
    paVehicleDamaged: {
        id: 'fnol.pa.views.pa-glass-details.Which vehicle was damaged?',
        defaultMessage: 'Which vehicle was involved?'
    },
    paGlassChooseVehicle: {
        id: 'fnol.pa.views.pa-glass-details.Choose Vehicle',
        defaultMessage: 'Choose Vehicle'
    },
    paGlassWhatHappened: {
        id: 'fnol.pa.views.pa-glass-details.Please describe what happened',
        defaultMessage: 'What happened?'
    },
    paGlassWhereDidThisHappenPropertyDamage: {
        id: 'fnol.pa.views.pa-glass-loss-details.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    },
    paGlassWhatHappened: {
        id: 'fnol.pa.views.pa-glass-loss-details.What Happened?',
        defaultMessage: 'What Happened?'
    }
});
